import { render, staticRenderFns } from "./RotateSquare5.vue?vue&type=template&id=702c7e42&scoped=true&"
import script from "./RotateSquare5.vue?vue&type=script&lang=js&"
export * from "./RotateSquare5.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare5.vue?vue&type=style&index=0&id=702c7e42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c7e42",
  null
  
)

export default component.exports